import { Component, inject } from '@angular/core';
import { KeycloakUserService } from '../../user/keycloak-user.service';

@Component({
  selector: 'app-user-trigger-inner',
  templateUrl: './user-trigger-inner.component.html',
})
export class UserTriggerInnerComponent {
  private readonly keycloakUserService: KeycloakUserService;

  constructor() {
    this.keycloakUserService = inject(KeycloakUserService);
  }

  public get user$() { return this.keycloakUserService.getUser(); }
}
